export default __webpack_public_path__ + "static/media/cal-img-white.e02328bc.png";